import client from "../Client/HttpClient";
import { ITuitionPriceLinesModel } from "@/interfaces/modules";

const ApiPath = "TuitionPriceLines";

export default {
    GetPriceLines: (): Promise<ITuitionPriceLinesModel[]> => client.get(`${ApiPath}`),
    GetPriceLineById: (data: ITuitionPriceLinesModel): Promise<ITuitionPriceLinesModel> => client.get(`${ApiPath}/${data.Id}`),
    PostPriceLine: (data: ITuitionPriceLinesModel): Promise<ITuitionPriceLinesModel> => client.post(`${ApiPath}`, data),
};
